module.exports = __webpack_public_path__ + "assets/img/phone-btn.7fd89b7d.png";